$(document).ready(function() {
  $(document).on('click', '.quantity-break', function() {
    $('.quantity__selector').hide();
    $('#add-quantity-button').hide();
  });
  $(document).on('click', '.quantity-break[for="quantity4"]', function() {
    $('.quantity__selector').show();
    $('#add-quantity-button').show();
  });
  $(document).on('click', '.quantity__selector .quantity .quantity__button', function() {
    let inputVal = $('.quantity__selector .quantity input').val();
    // console.log(inputVal);
    $('#quantity4').val(inputVal);
  });
  
    function updatePrices() {
        let quantity = parseInt($('.quantity__selector .quantity__input').val(), 10);
        let eachPrice = parseFloat($('.quantity-break[for="quantity4"] .variant-money-change .quantity-break__price').data('each-price').replace('$', ''));
        let totalPrice = eachPrice * quantity;
        
        // Update the each item price
        $('.quantity-break[for="quantity4"] .variant-money-change .quantity-break__price').text('$' + eachPrice.toFixed(2));
        
        // Update the total price
        $('.quantity-break[for="quantity4"] .variant-money-change .quantity-break__price[data-total-price]').text('$' + totalPrice.toFixed(2));
        
        // Update the total compare price
        let eachComparePrice = parseFloat($('.quantity-break[for="quantity4"] .variant-money-change .quantity-break__compare-price').data('each-compare-price').replace('$', ''));
        let totalComparePrice = eachComparePrice * quantity;
        $('.quantity-break[for="quantity4"] .variant-money-change .quantity-break__compare-price[data-total-compare-price]').text('$' + totalComparePrice.toFixed(2));
    }

    // Handle button clicks
    $(document).on('click', '.quantity__selector .quantity .quantity__button', function() {
        // Delay execution to ensure value is updated
        setTimeout(updatePrices, 100);
    });


  /*$(document).on('click', '#add-quantity-button', function() {
    $(this).parent().find('.quantity-break__variants .quantity-break__selector-item').last().clone().appendTo('.quantity-break__variants');
  });*/

  $('.color-swatch .color-swatch_hidden-label').click(function () {
    var title = $(this).attr('data-val'); 
    $('.cdk_name_opt_var').text(title)
  })
  
})


